import { roleMap } from '@/utils/permissions'
import { RootState } from '../../app/store'
import { UserRole } from '@/types/user.types'

export const selectAuthUser = (state: RootState) => state.auth.authUser
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated
export const selectAuthLoading = (state: RootState) => state.auth.isLoading
export const selectAuthError = (state: RootState) => state.auth.error
export const selectAuthInitialized = (state: RootState) => state.auth.isInitialized

export const selectAuthUserRole = (state: RootState): UserRole | null => {
  const authUser = state.auth.authUser
  ;
  if (!authUser || !authUser.role) return null

  return roleMap[authUser.role.toLowerCase()] || null
}